import { Chip, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { Module } from '@thro-types/modules-selections';

import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

import { SemesterEnum } from '../ParticipantConfiguration';

interface CustomPrioritizationProps {
  index: number;
}

const handleCustomPriority = (semesters, index, values, setFieldValue) => {
  setFieldValue(
    `participantsConfigurations[${index}].prioritization`,
    semesters?.target?.value?.map(semester => ({
      semester
    })) || []
  );
};

const createSelectItem = (semester, currentPrioritisation) => {
  const priority = currentPrioritisation?.findIndex(prio => prio.semester === semester);

  if (priority === undefined || priority === -1) {
    return (
      <MenuItem key={semester} value={semester}>
        {semester}
      </MenuItem>
    );
  }

  return (
    <MenuItem key={semester} value={semester}>
      <Typography>{`${priority + 1}. ${semester}`}</Typography>
    </MenuItem>
  );
};

export function CustomPrioritization({ index }: CustomPrioritizationProps) {
  const { t } = useTranslation();
  const { setFieldValue, values } = useFormikContext<Module>();
  return (
    <FormControl fullWidth variant="outlined">
      <Select
        autoWidth
        multiple={true}
        SelectDisplayProps={{
          style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 0.5,
            minHeight: 33,
            alignContent: 'center'
          }
        }}
        MenuProps={{
          //@ts-ignore
          getContentAnchorEl: () => null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          transformOrigin: {
            horizontal: 'left',
            vertical: 'top'
          },
          PaperProps: {
            style: {
              maxHeight: 220,
              width: 100
            }
          }
        }}
        value={
          values?.participantsConfigurations[index]?.prioritization?.map(prio => prio.semester) ||
          []
        }
        displayEmpty
        onChange={e => handleCustomPriority(e, index, values, setFieldValue)}
        renderValue={(selected: any) => {
          if (!selected || selected.length === 0) {
            return (
              <Typography style={{ color: 'grey' }}>
                {t(
                  translations.pages.modules.create.prioritizationAndApproval.participantConfiguration.customPrioEmpty()
                )}
              </Typography>
            );
          }
          return selected.map((value, index) => {
            return <Chip key={value} label={`${index + 1}. ${value}`} />;
          });
        }}
      >
        {Object.keys(SemesterEnum).map(semester =>
          createSelectItem(semester, values.participantsConfigurations[index].prioritization)
        )}
      </Select>
    </FormControl>
  );
}
